import React from 'react';
import { Promoter } from '../types';
import { Button, Flex, Text, Card } from './base-components';
import { useTranslation } from '../i18n/TranslationContext';

interface Props {
  promoter: Promoter;
  onSubscribe: (promoter: Promoter) => void;
}

export const PromoterCard: React.FC<Props> = ({ promoter, onSubscribe }) => {
  const { t } = useTranslation();
  return (
    <Card mb={4}>
      <Flex justify="between" align="center" gap={4}>
        <Flex direction="col">
          <Text variant="title">{promoter.name}</Text>
        </Flex>
        <Button
          variant="primary"
          disabled={promoter.is_subscribed}
          onClick={() => onSubscribe(promoter)}
          whitespace="nowrap"
        >
          {promoter.is_subscribed ? t('common.subscribed') : t('common.subscribe')}
        </Button>
      </Flex>
    </Card>
  );
};


